import { useNavigate } from "react-router-dom";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../../../redux/hooks";
import { FleetDocumentsDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { setFleetDocumentData } from "../../../../../redux/reducer/fleet.reducer";
import { fetchDeleteDocument } from "../../../../../redux/api/fleet.api";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";
import { getCurrentDate } from "../../../../../utils/dateAndTime";

function FleetDocumentsActionButton({
  crudData,
  itemId,
}: {
  itemId: string;
  crudData: FleetDocumentsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();

  const { CAR_DOCUMENT_EDIT_PERMISSION, CAR_DOCUMENT_DELETE_PERMISSION } = {
    CAR_DOCUMENT_EDIT_PERMISSION: isAuthorized(userRoles.CAR_DOCUMENT_EDIT),
    CAR_DOCUMENT_DELETE_PERMISSION: isAuthorized(userRoles.CAR_DOCUMENT_DELETE),
  };

  const handleEdit = () => {
    if (!CAR_DOCUMENT_EDIT_PERMISSION || !validDocument) return;
    dispatch(setFleetDocumentData(crudData));
    navigate(`edit?nrauto=${crudData.nrauto}`);
  };

  const handleDelete = () => {
    if (!CAR_DOCUMENT_DELETE_PERMISSION || !validDocument) return;
    dispatch(fetchDeleteDocument({ id: itemId, carId: crudData.id_auto }));
  };

  const today = getCurrentDate();
  const validDocument = crudData.doc_ts_stop > today;

  const items: ActionMenuItem[] = [
    {
      id: "edit",
      label: "Editeaza documentul",
      section: "manage",
      icon: "EDIT",
      tooltip: validDocument
        ? "Deschide editarea documentului masinii."
        : "Documentul nu mai este valabil si nu poate fi editat.",
      hidden: !CAR_DOCUMENT_EDIT_PERMISSION,
      disabled: !validDocument,
      onClick: handleEdit,
    },
    {
      id: "delete",
      label: "Sterge documentul",
      section: "danger",
      icon: "DELETE",
      color: "error",
      tooltip: validDocument
        ? "Sterge documentul masinii, dupa confirmare."
        : "Documentul nu mai este valabil si nu poate fi sters.",
      hidden: !CAR_DOCUMENT_DELETE_PERMISSION,
      disabled: !validDocument,
      withConfirmationModal: {
        modalTitle: `Doriti sa stergeti acest document pentru ${crudData.denumire}?`,
        modalLeftButtonColor: "inherit",
        modalRightButtonOnClick: handleDelete,
        modalRightButtonText: "Sterge",
        modalRightButtonColor: "error",
        modalLeftButtonText: "Anuleaza",
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={crudData.denumire}
      ariaLabel={`Actiuni pentru documentul ${crudData.denumire}`}
    />
  );
}

export default FleetDocumentsActionButton;
